import { createSlice } from "@reduxjs/toolkit";
import {
  fetchreorderlevel
} from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ItemWiseSlice = createSlice({
  name: "orderSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchreorderlevel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchreorderlevel.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchreorderlevel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch order List";
      })
  },
});

export default ItemWiseSlice.reducer;
